/* eslint-disable import/no-anonymous-default-export */
import { LISTAR_LUGARES } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_LUGARES:
      return {
        ...state,
        lugares: action.payload,
      };

    default:
      return state;
  }
};
